export interface LevelDef {
  level: number;
  name: string;
  xpRequired: number;
  emoji: string;
}

export const LEVELS: LevelDef[] = [
  { level: 1, name: 'Newbie', xpRequired: 0, emoji: '🌱' },
  { level: 2, name: 'Beginner', xpRequired: 50, emoji: '🌿' },
  { level: 3, name: 'Getting There', xpRequired: 150, emoji: '🌻' },
  { level: 4, name: 'Looking Good', xpRequired: 300, emoji: '✨' },
  { level: 5, name: 'Head Turner', xpRequired: 500, emoji: '🔥' },
  { level: 6, name: 'Top 10%', xpRequired: 800, emoji: '💎' },
  { level: 7, name: 'Photogenic', xpRequired: 1200, emoji: '📸' },
  { level: 8, name: 'Photo Pro', xpRequired: 2000, emoji: '🏅' },
  { level: 9, name: 'Matchmaker', xpRequired: 3000, emoji: '💫' },
  { level: 10, name: 'Legend', xpRequired: 5000, emoji: '🏆' },
];

/** Given a total XP value, return the current level number (1-10). */
export function getLevelFromXP(xp: number): number {
  for (let i = LEVELS.length - 1; i >= 0; i--) {
    if (xp >= LEVELS[i].xpRequired) {
      return LEVELS[i].level;
    }
  }
  return 1;
}

/** Return the LevelDef for a given level number. */
export function getLevelDef(level: number): LevelDef {
  return LEVELS[level - 1] ?? LEVELS[0];
}

/** Return XP progress within the current level as a 0-1 ratio. */
export function getLevelProgress(xp: number): number {
  const level = getLevelFromXP(xp);
  const current = LEVELS[level - 1];
  const next = LEVELS[level]; // undefined at max level
  if (!next) return 1;
  return (xp - current.xpRequired) / (next.xpRequired - current.xpRequired);
}
